module.exports = __webpack_public_path__ + "static/img/img-logo-bprs.e95cbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-bprs.png
// module id = ye9Q
// module chunks = 36